import { action, makeObservable, observable, runInAction } from 'mobx';
import { createContext, useContext } from 'react';
import { bpHistory } from 'global/bpHistory';
import { CensusGroupDomainDependencies, CensusGroupModule } from 'store/modules/census/group-based/censusGroupModule';
import ICensusUploadPageStore from 'store/modules/census/iCensusUploadPageStore';

export interface CensusInitiateAddEeDomainDependencies extends CensusGroupDomainDependencies {
  cartId: string;
}

export default class CensusInitiateAddEePageStore extends ICensusUploadPageStore<
  CensusInitiateAddEeDomainDependencies,
  CensusGroupModule
> {
  protected _censusModule: CensusGroupModule;
  protected _domainData: CensusInitiateAddEeDomainDependencies;

  public async getCensusData(): Promise<void> {
    this.setIsLoading(true);
    await runInAction(async () => {
      await this._censusModule.getPreviouslyUploadedFiles();
    });
    await runInAction(async () => {
      await this._censusModule.uploadExistingCensus();
    });
    this.setIsLoading(false);
  }

  public onCompleteRedirect(): void {
    bpHistory.push(
      `/census-initiate-add-employees-review/${this._domainData.groupId}?periodId=${this._domainData.enrollmentPeriodId}&cartId=${this._domainData.cartId}`,
    );
  }

  constructor(domainData: CensusInitiateAddEeDomainDependencies) {
    super();
    this._censusModule = new CensusGroupModule({
      enrollmentPeriodId: domainData.enrollmentPeriodId || '',
      groupId: domainData.groupId || '',
    });
    this._domainData = domainData;

    makeObservable<CensusInitiateAddEePageStore, '_censusModule' | '_domainData'>(this, {
      _censusModule: observable,
      _domainData: observable,

      getCensusData: action.bound,
      onCompleteRedirect: action.bound,
    });
  }
}

const CensusInitiateAddEePageStoreContext = createContext(
  new CensusInitiateAddEePageStore({
    enrollmentPeriodId: 'stub-period-id',
    groupId: 'stub-group-id',
    cartId: 'stub-cart-id',
  }),
);

export const useCensusInitiateAddEePageStoreContext = (): CensusInitiateAddEePageStore => {
  return useContext(CensusInitiateAddEePageStoreContext);
};

export { CensusInitiateAddEePageStoreContext };
